// src/pages/HelpPage.tsx

import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Icon,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";
import { EmailIcon, PhoneIcon } from "@chakra-ui/icons";

const HelpPage: React.FC = () => {
  const bg = useColorModeValue("gray.50", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <Box
      maxW="600px"
      mx="auto"
      mt={10}
      p={8}
      borderWidth={1}
      borderColor={borderColor}
      borderRadius="lg"
      bg={bg}
      boxShadow="md"
    >
      <Heading size="lg" mb={4}>
        Help & Support
      </Heading>

      <Text mb={6} fontSize="md">
        If you have any questions, issues, or need assistance, feel free to
        reach out to us using the details below. We’re happy to help!
      </Text>

      <VStack spacing={4} align="start">
        <Box>
          <Icon as={EmailIcon} mr={2} color="blue.500" />
          <Text as="span" fontWeight="bold">
            Email:
          </Text>{" "}
          <Link href="mailto:lords@lordsforerunner.net" color="blue.600">
            lords@lordsforerunner.net
          </Link>
        </Box>

        <Box>
          <Icon as={PhoneIcon} mr={2} color="blue.500" />
          <Text as="span" fontWeight="bold">
            Phone:
          </Text>{" "}
          <Link href="tel:+234 9048220660" color="blue.600">
            +234 9048220660
          </Link>
        </Box>
      </VStack>
    </Box>
  );
};

export default HelpPage;
